<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">门店列表</p>
		</sub-ibox-title>
		<!--<section class="fx filter-list">
			<div class="fx fx-wrap fx-fill"></div>
			<z-search v-model="params.search" placeholder="请输入门店名称..."></z-search>
		</section>-->
		<!--列表-->
		<div id="list">
			<z-table :offset="0" :count="10000" :total-count="envelopeList.total_count">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in envelopeList.list || []">
					<td>{{envelopeList.shop_list[item.shop_id]}}</td>
					<td>{{item.dealing_amount | filterMoney}}</td>
					<td>{{item.dealing_count}}</td>
					<td>{{item.use_amount | filterMoney}}</td>
					<td>{{item.use_count}}</td>
					<td class="operating">
						<a class="operat-btn" @click="handleShowInfo(item.shop_id)"><i class="icon-look"></i><span>详情</span></a>
					</td>
				</tr>
			</z-table>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'RedPacketShopListPage',
		components: {},
		data() {
			return {
				id: '',
				columns: ['门店名称', '已发放总额', '已发放个数', '红包抵扣总额', '红包使用个数', '操作'],
				params: {
					search: ''
				},
				data: {}
			}
		},
		async mounted() {
			this.id = this.$route.query.envelopeId;
			if(this.$re_Number(this.id)) await this.handleShopEnvelopeList();	
		},
		computed: {
			...mapState({
				envelopeList: state => state.envelope.envelopeShopList
			})
		},
		methods: {
			async handleShopEnvelopeList() {
				await this.getShopEnvelopeList({id: this.id});
				this.$log('获取门店红包列表成功');
			},
			
			//查看具体门店中用户领取红包使用情况
			handleShowInfo(id = null) {
				this.$router.push({ name: 'redPacketShopRecordPage', query: { envelopeId: this.id, shopId: id}});
			},
			...mapActions(['getShopEnvelopeList']),
		},
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	table img {
		width: 50px;
		height: 50px;
	}
	
	.pages {
		background: #FFFFFF;
		border: 1px solid #EBEDEE;
    		border-bottom: none;
		.filter-list {
			padding: 1rem;
		}
	}
	
	.table-cont {
		background: $color-white;
	}
	
	.popup-cont {
		width: 400px;
		background: #fff;
		transform-origin: 0 -20%;
		padding: 20px;
		.btn-close {
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i {
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active {
				i {
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.pic-cont {
			width: 360px;
			height: 512px;
			background: #fff url(../../../../assets/img/code_mould.png) center center no-repeat;
			background-size: 100%;
			#qrcode {
				background: #fff;
				padding: 10px;
				width: 150px;
				height: 150px;
				position: absolute;
				top: 205px;
				left: 125px;
			}
		}
		.btn-down {
			width: 100%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 18px;
			text-align: center;
			padding: 10px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active {
				opacity: 1;
				background: darken($color-main, 5%);
				transform: scale(0.95);
			}
		}
	}
	
	table .operating {
		i,
		span {
			width: 68px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// RedPacketShopListPage.vue?7554ab8e